<vg-vgn-nav app-id="VMF" stickiness="true">
  <router-outlet></router-outlet>
  <c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
  
  <quick-ticket-drawer
    (orderSubmitted)="onOrderSubmitted($event)"
  ></quick-ticket-drawer>
</vg-vgn-nav>
